import { RawRigTableEvent } from '../utils/type'
import {
    fetchEntityEndTimestamp,
    fetchEntityStartTimestamp,
    INTERVENTION_API,
    RIG_TABLE_API,
    RUN_API,
    SECTION_API
} from './api'

export interface RigTableTimestamps {
    end?: number
    start?: number
}

export async function fetchRigTableTimestamps(event: RawRigTableEvent): Promise<RigTableTimestamps | undefined> {
    if (!event.id) {
        const start = await fetchEntityStartTimestamp(event.intervention_id, RIG_TABLE_API, INTERVENTION_API)
        return { start: start || event.start }
    }
}
